import { render, staticRenderFns } from "./TroubleTicketForm.vue?vue&type=template&id=273a47fc&scoped=true"
import script from "./TroubleTicketForm.vue?vue&type=script&lang=js"
export * from "./TroubleTicketForm.vue?vue&type=script&lang=js"
import style0 from "./TroubleTicketForm.vue?vue&type=style&index=0&id=273a47fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a47fc",
  null
  
)

export default component.exports